import { createContext, useContext, useState, useCallback } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { useFlags } from "./flags";

const KEY = "xp_sound_on";
const SoundContext = createContext({ soundOn: false, toggleSound: () => {} });

export const SoundProvider = ({ children }) => {
  const [soundOn, setSoundOn] = useState(() => localStorage.getItem(KEY) !== "0");
  const toggleSound = useCallback(() => {
    setSoundOn((v) => {
      localStorage.setItem(KEY, v ? "0" : "1");
      if (v) {
        window.__xpStoryAudio?.pause();
        window.__xpStoryAudio = null;
      }
      return !v;
    });
  }, []);
  return <SoundContext.Provider value={{ soundOn, toggleSound }}>{children}</SoundContext.Provider>;
};

export const useSound = () => {
  const { soundOn, toggleSound } = useContext(SoundContext);
  const flags = useFlags();
  const voiceReady = !!flags?.voice_ready;
  return { soundOn: soundOn && voiceReady, toggleSound, voiceReady, rawSoundOn: soundOn };
};

export const SoundToggle = () => {
  const { toggleSound, voiceReady, rawSoundOn } = useSound();
  if (!voiceReady) return null;
  return (
    <div className="sticky top-9 z-40 h-0 flex justify-end pr-3">
      <button
        data-testid="sound-toggle"
        onClick={toggleSound}
        aria-label={rawSoundOn ? "Turn VeerGi voice off" : "Turn VeerGi voice on"}
        title={rawSoundOn ? "VeerGi voice: ON" : "VeerGi voice: OFF (tap to enable on this device)"}
        className={`mt-2 rounded-full w-10 h-10 flex items-center justify-center border backdrop-blur transition-colors ${
          rawSoundOn ? "bg-[#D4AF37] text-black border-[#D4AF37]" : "bg-black/60 text-white/60 border-white/20"
        }`}
      >
        {rawSoundOn ? <Volume2 size={16} /> : <VolumeX size={16} />}
      </button>
    </div>
  );
};
